export const formatFrequency = (value: number): string => value.toFixed(2);

export const formatPercent = (value: number): string =>
  `${((Number.isFinite(value) ? value : 0) * 100).toFixed(1)}%`;

export const formatPercentagePoint = (value: number): string => {
  const formattedValue = `${((Number.isFinite(value) ? value : 0) * 100).toFixed(1)} pts`;

  return value > 0 ? `+${formattedValue}` : formattedValue;
};
